import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { versionHistoryQueryParamKey } from "../../../../report-lists/reports/utilities/editReportUrl";
import { useAppDispatch } from "../../../store/hooks/useAppDispatch";
import { createUiSettingsAction } from "../../../store/utils/storeUtils";

const useVersionHistoryUrlParam = (): void => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const versionHistoryRequested = searchParams.get(versionHistoryQueryParamKey) !== null;

  useEffect(() => {
    if (!versionHistoryRequested) {
      return;
    }
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.delete(versionHistoryQueryParamKey);
    navigate({ search: nextSearchParams.toString() }, { replace: true });
    dispatch(createUiSettingsAction("setVersionHistoryOpen", true));
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [versionHistoryRequested]);
};

export default useVersionHistoryUrlParam;
